module.exports = __webpack_public_path__ + "static/media/emoji.7da98505.svg";